import { initMatomoOptOut } from '@ts/common/matomo';
import '@ts/pages/page-defaults';
// Must stay in the module body: the entry is deferred, so the DOM is parsed and
// page-defaults' `load` listener (which bootstraps the tracker) has not run yet.
initMatomoOptOut();
